import { Control } from "ol/control";
import manual from "/Manual de Usuario.pdf";

class Ayuda extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const tipLabel = options.tipLabel ? options.tipLabel : "Manual de ayuda";

    const button = document.createElement("button");
    button.innerText = "?";
    button.title = tipLabel;
    const element = document.createElement("div");
    element.className = "ayuda ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener("click", this.ayudaPage, false);
  }

  ayudaPage() {
    window.open(manual, "_blank");
  }
}
export default Ayuda;
